
import SamplingPointListSupportComponent from "@/components/samplingPoints/SamplingPointListSupport.component.vue";
import SamplingPointMapComponent from "@/components/samplingPoints/SamplingPointMap.component.vue";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import { defineComponent, ref } from "vue";
import { SamplingPoint } from "@/types/samplingpoint.type";

import securityService from "@/service/security.service";
import { AppType, AppRole } from "@/types/app.type";
import { getSamplingPointsList } from "@/service/samplingpoint.service";
import { Filter, OrderByCondition } from "@/types/filter.type";
import { SearchSamplingPoint } from "@/types/search.type";
import ObserverComponent from "@/components/Observer.component.vue";

export default defineComponent({
  components: {
    SamplingPointListSupportComponent,
    SamplingPointMapComponent,
    PageButtonsComponent,
    ObserverComponent,
  },

  setup() {
    const isAppAdmin = securityService.isApp(AppType.ADMIN);
    const appIsAdminAndRoleIsAdmin = isAppAdmin && securityService.canAccessToApp(AppType.ADMIN);
    const listCanWrite = appIsAdminAndRoleIsAdmin;
    const canCreate = appIsAdminAndRoleIsAdmin;
    const showMap = ref(securityService.isApp(AppType.SUPPORT) ? false : true);
    const isAppDemo = securityService.hasRole(AppRole.DEMOS) ? true : false;
    return {
      appIsAdminAndRoleIsAdmin,
      listCanWrite,
      canCreate,
      showMap,
      isAppDemo,
    };
  },

  data() {
    return {
      showEntityForm: false,
      entityForm: undefined as undefined | SamplingPoint,
      samplingPointList: [] as SamplingPoint[],
      loading: false,
      hasMore: true,
      search: undefined as SearchSamplingPoint | undefined,
      samplingPoints: [] as SamplingPoint[],
      currentPage: 1 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
    };
  },

  methods: {
    // goBack() {
    //   this.$router.push("/support");
    // },
    getFilter() {
      const filter: Filter = {};

      filter.fields = {};
      switch (this.search?.queryField) {
        case "ALL":
          filter.multi = this.search.query;
          break;
        case "SAMPLINGPOINT_NAME":
          filter.fields["samplingPoint.name"] = {
            operator: "contains",
            value: this.search.query,
          };
          break;
        case "SAMPLINGPOINT_CODE":
          filter.fields["samplingPoint.code"] = {
            operator: "contains",
            value: this.search.query,
          };
          break;
        case "SAMPLINGPOINT_RECEIVINGMEDIUM":
          filter.fields["samplingPoint.receivingMedium"] = {
            operator: "contains",
            value: this.search.query,
          };

          break;

        default:
          break;
      }

      return filter;
    },

    /**
     * refresh samplingPoint item from list items
     * @param item
     */
    async refreshEntities(
      item: SamplingPoint | undefined = undefined,
      search: SearchSamplingPoint | undefined
    ) {
      this.loading = false;
      this.search = search;

      if (item) {
        // Actualizar un elemento específico
        const index = this.samplingPoints.findIndex((i) => i.id === item.id);
        if (index !== -1) {
          this.samplingPoints.splice(index, 1, item);
        }
      } else {
        // Recargar la lista completa
        this.samplingPoints = [];
        this.currentPage = 1;
        await this.showMore();
      }
    },
    async showMore() {
      // - get result for current page
      this.hasMore = false;
      const rowPerPage = 10;
      const orderBy: OrderByCondition = {
        "samplingPoint.lastEstimation": {
          order: "DESC",
          nulls: "NULLS LAST",
        },
      };
      try {
        const { data, totalRows } = await getSamplingPointsList(
          this.currentPage,
          rowPerPage,
          this.getFilter(),
          orderBy,
          undefined
        );
        // - concat result array
        this.samplingPoints = [...this.samplingPoints, ...data];
        // - check if exist more result
        this.hasMore = totalRows > this.currentPage * rowPerPage;

        this.currentPage++;
      } catch (e) {
        this.samplingPointList = [];
        this.loading = true;
      } finally {
        this.loading = true;
      }
    },

    /**
     * open samplingPoints formDialog
     * @param item
     */
    openEntityFormDialog(item: SamplingPoint | undefined = undefined) {
      this.entityForm = item;
      this.showEntityForm = true;
    },

    /**
     * close samplingPoints formDialog
     */
    closeEntityFormDialog() {
      this.showEntityForm = false;
      this.entityForm = undefined;
    },

    changeView() {
      this.showMap = !this.showMap;
    },
  },
});
